import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-207">
      {children}
    </motion.div>;
}
export function StaggerContainer({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <motion.div initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-50px'
  }} variants={{
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  }} className={className} data-id="element-208">
      {children}
    </motion.div>;
}
export function StaggerItem({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <motion.div variants={{
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  }} className={className} data-id="element-209">
      {children}
    </motion.div>;
}